import React from "react";
import { Col, Row } from "react-bootstrap";
import TitleHeader from "../Header/TitleHeader";
const SectionD = ({ id }) => {
  return (
    <section>
      <TitleHeader title={"Why Choose Me"} />
      <div className="desc_Con textContainer">
        <text className="regularText">
          With a focus on quality, creativity, and customer satisfaction, I work
          closely with our clients to understand their business objectives and
          build custom software that exceeds their expectations.
        </text>
      </div>
      <div className="sectionE-container">
        <div className="record_wrapper">
          <Row className="record_list">
            <Col sm={12} md={3} lg={3} className="record">
              <h1>10 +</h1>
              <p> Active Respositories </p>
            </Col>
            <Col sm={12} md={3} lg={3} className="record">
              <h1>25 +</h1>
              <p> Projects Done </p>
            </Col>
            <Col sm={12} md={3} lg={3} className="record">
              <h1>24/7 </h1>
              <p>Dedicated Support</p>
            </Col>
            <Col sm={12} md={3} lg={3} className="record">
              <h1>5 + </h1>
              <p> Year of Experience </p>
            </Col>
          </Row>
        </div>
      </div>
    </section>
  );
};
export default SectionD;
